export default __webpack_public_path__ + "static/topic7-a83490b5b2e6101eeb9a051b0a1d023f.png";